export const getPaginationResultText = (meta, totalText) => {
  if (!meta) return "";

  const { from, to, total, per_page } = meta;

  if (total === 0) {
    return `0 ${totalText}`;
  }

  return `${from} - ${total > per_page ? to : total} of ${total} ${totalText}`;
};
